// AG Grid's locale text function looks for this exact token in a localised
// string and replaces each occurrence with the next value it was handed
// (`localisedText.replace('$' + '{variable}', ...)` in ag-grid-community). It is
// not a template placeholder of ours, so it is assembled here and interpolated
// below instead of being written out inside quoted text.
const DOLLAR = '$';
const VARIABLE = `${DOLLAR}{variable}`;

export const AG_GRID_LOCALE_HU: Record<string, string> = {
  // Set Filter
  selectAll: '(Összes kiválasztása)',
  selectAllSearchResults: '(Összes keresési eredmény kiválasztása)',
  addCurrentSelectionToFilter: 'Jelenlegi kiválasztás hozzáadása a szűrőhöz',
  searchOoo: 'Keresés...',
  blanks: '(Üres)',
  noMatches: 'Nincs találat',

  // Number Filter & Text Filter
  filterOoo: 'Szűrő...',
  equals: 'Egyenlő',
  notEqual: 'Nem egyenlő',
  blank: 'Üres',
  notBlank: 'Nem üres',
  empty: 'Válasszon egyet',

  // Number Filter
  lessThan: 'Kisebb mint',
  greaterThan: 'Nagyobb mint',
  lessThanOrEqual: 'Kisebb vagy egyenlő',
  greaterThanOrEqual: 'Nagyobb vagy egyenlő',
  inRange: 'Között',
  inRangeStart: 'Ettől',
  inRangeEnd: 'Eddig',

  // Text Filter
  contains: 'Tartalmazza',
  notContains: 'Nem tartalmazza',
  startsWith: 'Ezzel kezdődik',
  endsWith: 'Ezzel végződik',

  // Date Filter
  dateFormatOoo: 'yyyy-mm-dd',
  before: 'Előtt',
  after: 'Után',

  // Filter Conditions
  andCondition: 'ÉS',
  orCondition: 'VAGY',

  // Filter Buttons
  applyFilter: 'Alkalmaz',
  resetFilter: 'Alaphelyzet',
  clearFilter: 'Töröl',
  cancelFilter: 'Mégse',

  // Filter Titles
  textFilter: 'Szövegszűrő',
  numberFilter: 'Számszűrő',
  dateFilter: 'Dátumszűrő',
  setFilter: 'Beállított szűrő',

  // Group Column Filter
  groupFilterSelect: 'Mező kiválasztása:',

  // Advanced Filter
  advancedFilterContains: 'tartalmazza',
  advancedFilterNotContains: 'nem tartalmazza',
  advancedFilterTextEquals: 'egyenlő',
  advancedFilterTextNotEqual: 'nem egyenlő',
  advancedFilterStartsWith: 'ezzel kezdődik',
  advancedFilterEndsWith: 'ezzel végződik',
  advancedFilterBlank: 'üres',
  advancedFilterNotBlank: 'nem üres',
  advancedFilterEquals: '=',
  advancedFilterNotEqual: '!=',
  advancedFilterGreaterThan: '>',
  advancedFilterGreaterThanOrEqual: '>=',
  advancedFilterLessThan: '<',
  advancedFilterLessThanOrEqual: '<=',
  advancedFilterTrue: 'igaz',
  advancedFilterFalse: 'hamis',
  advancedFilterAnd: 'ÉS',
  advancedFilterOr: 'VAGY',
  advancedFilterApply: 'Alkalmaz',
  advancedFilterBuilder: 'Építő',
  advancedFilterValidationMissingColumn: 'Hiányzó oszlop',
  advancedFilterValidationMissingOption: 'Hiányzó opció',
  advancedFilterValidationMissingValue: 'Hiányzó érték',
  advancedFilterValidationInvalidColumn: 'Nem található oszlop',
  advancedFilterValidationInvalidOption: 'Nem található opció',
  advancedFilterValidationMissingQuote: 'Az érték záró idézőjele hiányzik',
  advancedFilterValidationNotANumber: 'Az érték nem szám',
  advancedFilterValidationInvalidDate: 'Az érték nem érvényes dátum',
  advancedFilterValidationMissingCondition: 'Hiányzó feltétel',
  advancedFilterValidationJoinOperatorMismatch:
    'A feltételen belüli csatlakozási operátoroknak ugyanazoknak kell lenniük',
  advancedFilterValidationInvalidJoinOperator: 'Nem található csatlakozási operátor',
  advancedFilterValidationMissingEndBracket: 'Hiányzó záró zárójel',
  advancedFilterValidationExtraEndBracket: 'Túl sok záró zárójel',
  advancedFilterValidationMessage: `Kifejezés hibát tartalmaz. ${VARIABLE} - ${VARIABLE}.`,
  advancedFilterValidationMessageAtEnd: `Kifejezés hibát tartalmaz. ${VARIABLE} a kifejezés végén.`,
  advancedFilterBuilderTitle: 'Haladó Szűrő',
  advancedFilterBuilderApply: 'Alkalmaz',
  advancedFilterBuilderCancel: 'Mégse',
  advancedFilterBuilderAddButtonTooltip: 'Szűrő vagy csoport hozzáadása',
  advancedFilterBuilderRemoveButtonTooltip: 'Eltávolít',
  advancedFilterBuilderMoveUpButtonTooltip: 'Mozgatás fel',
  advancedFilterBuilderMoveDownButtonTooltip: 'Mozgatás le',
  advancedFilterBuilderAddJoin: 'Csoport hozzáadása',
  advancedFilterBuilderAddCondition: 'Szűrő hozzáadása',
  advancedFilterBuilderSelectColumn: 'Válasszon egy oszlopot',
  advancedFilterBuilderSelectOption: 'Válasszon egy opciót',
  advancedFilterBuilderEnterValue: 'Adjon meg egy értéket...',
  advancedFilterBuilderValidationAlreadyApplied: 'A jelenlegi szűrő már alkalmazva van.',
  advancedFilterBuilderValidationIncomplete: 'Nem minden feltétel teljes.',
  advancedFilterBuilderValidationSelectColumn: 'Oszlopot kell választani.',
  advancedFilterBuilderValidationSelectOption: 'Opciót kell választani.',
  advancedFilterBuilderValidationEnterValue: 'Értéket kell megadni.',

  // Side Bar
  columns: 'Oszlopok',
  filters: 'Szűrők',

  // columns tool panel
  pivotMode: 'Pivot mód',
  groups: 'Sor csoportok',
  rowGroupColumnsEmptyMessage: 'Húzza ide a sor csoportok beállításához',
  values: 'Értékek',
  valueColumnsEmptyMessage: 'Húzza ide az összesítéshez',
  pivots: 'Oszlop címkék',
  pivotColumnsEmptyMessage: 'Húzza ide az oszlop címkék beállításához',

  // Header of the Default Group Column
  group: 'Csoport',

  // Row Drag
  rowDragRow: 'sor',
  rowDragRows: 'sorok',

  // Other
  loadingOoo: 'Betöltés...',
  loadingError: 'HIBA',
  noRowsToShow: 'Nincs megjeleníthető sor',
  enabled: 'Engedélyezve',

  // Menu
  pinColumn: 'Oszlop rögzítése',
  pinLeft: 'Rögzítés balra',
  pinRight: 'Rögzítés jobbra',
  noPin: 'Nincs rögzítés',
  valueAggregation: 'Érték összesítése',
  noAggregation: 'Nincs',
  autosizeThiscolumn: 'Oszlop automatikus méretezése',
  autosizeAllColumns: 'Minden oszlop automatikus méretezése',
  groupBy: 'Csoportosítás',
  ungroupBy: 'Csoport feloldása',
  ungroupAll: 'Összes csoport feloldása',
  addToValues: `Hozzáadás ${VARIABLE} az értékekhez`,
  removeFromValues: `Eltávolítás ${VARIABLE} az értékekből`,
  addToLabels: `Hozzáadás ${VARIABLE} a címkékhez`,
  removeFromLabels: `Eltávolítás ${VARIABLE} a címkékből`,
  resetColumns: 'Oszlopok visszaállítása',
  expandAll: 'Minden sor csoport kibontása',
  collapseAll: 'Minden sor csoport bezárása',
  copy: 'Másolás',
  ctrlC: 'Ctrl+C',
  ctrlX: 'Ctrl+X',
  copyWithHeaders: 'Másolás fejlécével',
  copyWithGroupHeaders: 'Másolás csoport fejlécével',
  cut: 'Kivágás',
  paste: 'Beillesztés',
  ctrlV: 'Ctrl+V',
  export: 'Exportálás',
  csvExport: 'CSV exportálás',
  excelExport: 'Excel exportálás',
  columnFilter: 'Oszlopszűrő',
  columnChooser: 'Oszlopok kiválasztása',
  sortAscending: 'Rendezés növekvő sorrendbe',
  sortDescending: 'Rendezés csökkenő sorrendbe',
  sortUnSort: 'Rendezés törlése',

  // Enterprise Menu Aggregation and Status Bar
  sum: 'Összeg',
  first: 'Első',
  last: 'Utolsó',
  min: 'Min',
  max: 'Max',
  none: 'Nincs',
  count: 'Darabszám',
  avg: 'Átlag',
  filteredRows: 'Szűrt',
  selectedRows: 'Kiválasztott',
  totalRows: 'Összes sor',
  totalAndFilteredRows: 'Sorok',

  more: 'Több',
  page: 'Oldal',
  pageLastRowUnknown: '?',
  nextPage: 'Következő oldal',
  lastPage: 'Utolsó oldal',
  firstPage: 'Első oldal',
  previousPage: 'Előző oldal',
  pageSizeSelectorLabel: 'Oldalméret:',
  footerTotal: 'Összesen',

  // Pivoting
  pivotColumnGroupTotals: 'Összesen',

  // Enterprise Menu (Charts)
  pivotChartAndPivotMode: 'Pivot diagram és pivot mód',
  pivotChart: 'Pivot diagram',
  chartRange: 'Diagram tartomány',

  columnChart: 'Oszlop',
  groupedColumn: 'Csoportosított',
  stackedColumn: 'Halmozott',
  normalizedColumn: '100% Halmozott',

  barChart: 'Sáv',
  groupedBar: 'Csoportosított',
  stackedBar: 'Halmozott',
  normalizedBar: '100% Halmozott',

  pieChart: 'Torta',
  pie: 'Torta',
  donut: 'Donut',

  line: 'Vonal',

  xyChart: 'X Y (Szórt)',
  scatter: 'Szórt',
  bubble: 'Buborék',

  areaChart: 'Terület',
  area: 'Terület',
  stackedArea: 'Halmozott',
  normalizedArea: '100% Halmozott',

  histogramChart: 'Hisztogram',
  histogramFrequency: 'Gyakoriság',

  polarChart: 'Polár',
  radarLine: 'Radar vonal',
  radarArea: 'Radar terület',
  nightingale: 'Nightingale',
  radialColumn: 'Radiális oszlop',
  radialBar: 'Radiális sáv',

  statisticalChart: 'Statisztikai',
  boxPlot: 'Box Plot',
  rangeBar: 'Tartomány sáv',
  rangeArea: 'Tartomány terület',

  hierarchicalChart: 'Hierarchikus',
  treemap: 'Fa diagram',
  sunburst: 'Sunburst',

  specializedChart: 'Speciális',
  waterfall: 'Vízesés',
  heatmap: 'Hőtérkép',

  combinationChart: 'Kombináció',
  columnLineCombo: 'Oszlop és vonal',
  AreaColumnCombo: 'Terület és oszlop',

  // Charts
  pivotChartTitle: 'Pivot diagram',
  rangeChartTitle: 'Tartomány diagram',
  settings: 'Diagram',
  data: 'Adatok',
  format: 'Formátum',
  categories: 'Kategóriák',
  defaultCategory: '(Nincs)',
  series: 'Sorozatok',
  switchCategorySeries: 'Kategória / Sorozat váltása',
  categoryValues: 'Kategória értékek',
  seriesLabels: 'Sorozat címkék',
  aggregate: 'Összesítés',
  xyValues: 'X Y értékek',
  paired: 'Páros mód',
  axis: 'Tengely',
  xAxis: 'Vízszintes tengely',
  yAxis: 'Függőleges tengely',
  polarAxis: 'Polár tengely',
  radiusAxis: 'Sugár tengely',
  navigator: 'Navigátor',
  zoom: 'Nagyítás',
  animation: 'Animáció',
  crosshair: 'Iránytű',
  color: 'Szín',
  thickness: 'Vastagság',
  preferredLength: 'Előnyben részesített hossz',
  xType: 'X típus',
  axisType: 'Tengely típus',
  automatic: 'Automatikus',
  category: 'Kategória',
  number: 'Szám',
  time: 'Idő',
  timeFormat: 'Idő formátum',
  autoRotate: 'Automatikus forgatás',
  labelRotation: 'Forgatás',
  circle: 'Kör',
  polygon: 'Sokszög',
  orientation: 'Tájolás',
  fixed: 'Rögzített',
  parallel: 'Párhuzamos',
  perpendicular: 'Merőleges',
  radiusAxisPosition: 'Pozíció',
  ticks: 'Jelzések',
  gridLines: 'Rácsvonalak',
  width: 'Szélesség',
  height: 'Magasság',
  length: 'Hosszúság',
  padding: 'Kitöltés',
  spacing: 'Távolság',
  chart: 'Diagram',
  title: 'Cím',
  titlePlaceholder: 'Diagram címe - dupla kattintás a szerkesztéshez',
  background: 'Háttér',
  font: 'Betűtípus',
  top: 'Fent',
  right: 'Jobbra',
  bottom: 'Lent',
  left: 'Balra',
  labels: 'Címkék',
  calloutLabels: 'Callout címkék',
  sectorLabels: 'Sektor címkék',
  positionRatio: 'Pozíció arány',
  size: 'Méret',
  shape: 'Forma',
  minSize: 'Minimális méret',
  maxSize: 'Maximális méret',
  legend: 'Jelmagyarázat',
  position: 'Pozíció',
  markerSize: 'Jelölő mérete',
  markerStroke: 'Jelölő vonalvastagsága',
  markerPadding: 'Jelölő kitöltése',
  itemSpacing: 'Elemek távolsága',
  itemPaddingX: 'Elemek vízszintes kitöltése',
  itemPaddingY: 'Elemek függőleges kitöltése',
  layoutHorizontalSpacing: 'Vízszintes távolság',
  layoutVerticalSpacing: 'Függőleges távolság',
  strokeWidth: 'Vonalvastagság',
  offset: 'Eltolás',
  offsets: 'Eltolások',
  tooltips: 'Tooltippek',
  callout: 'Callout',
  markers: 'Jelölők',
  shadow: 'Árnyék',
  blur: 'Homályosítás',
  xOffset: 'X eltolás',
  yOffset: 'Y eltolás',
  lineWidth: 'Vonalvastagság',
  lineDash: 'Vonal típus',
  lineDashOffset: 'Vonal típus eltolás',
  scrollingZoom: 'Görgetés',
  scrollingStep: 'Görgetési lépés',
  selectingZoom: 'Kijelölés',
  durationMillis: 'Időtartam (ms)',
  crosshairLabel: 'Címke',
  crosshairSnap: 'Csomóponthoz illesztés',
  normal: 'Normál',
  bold: 'Félkövér',
  italic: 'Dőlt',
  boldItalic: 'Félkövér dőlt',
  predefined: 'Előre meghatározott',
  fillOpacity: 'Kitöltés átlátszóság',
  strokeColor: 'Vonal színe',
  strokeOpacity: 'Vonal átlátszóság',
  miniChart: 'Mini-diagram',
  histogramBinCount: 'Bin count',
  connectorLine: 'Összekötő vonal',
  seriesItems: 'Sorozat elemek',
  seriesItemType: 'Elem típus',
  seriesItemPositive: 'Pozitív',
  seriesItemNegative: 'Negatív',
  seriesItemLabels: 'Elem címkék',
  columnGroup: 'Oszlop',
  barGroup: 'Sáv',
  pieGroup: 'Torta',
  lineGroup: 'Vonal',
  scatterGroup: 'X Y (Szórt)',
  areaGroup: 'Terület',
  polarGroup: 'Polár',
  statisticalGroup: 'Statisztikai',
  hierarchicalGroup: 'Hierarchikus',
  specializedGroup: 'Speciális',
  combinationGroup: 'Kombináció',
  groupedColumnTooltip: 'Csoportosított',
  stackedColumnTooltip: 'Halmozott',
  normalizedColumnTooltip: '100% Halmozott',
  groupedBarTooltip: 'Csoportosított',
  stackedBarTooltip: 'Halmozott',
  normalizedBarTooltip: '100% Halmozott',
  pieTooltip: 'Torta',
  donutTooltip: 'Donut',
  lineTooltip: 'Vonal',
  groupedAreaTooltip: 'Terület',
  stackedAreaTooltip: 'Halmozott',
  normalizedAreaTooltip: '100% Halmozott',
  scatterTooltip: 'Szórt',
  bubbleTooltip: 'Buborék',
  histogramTooltip: 'Hisztogram',
  radialColumnTooltip: 'Radiális oszlop',
  radialBarTooltip: 'Radiális sáv',
  radarLineTooltip: 'Radar vonal',
  radarAreaTooltip: 'Radar terület',
  nightingaleTooltip: 'Nightingale',
  rangeBarTooltip: 'Tartomány sáv',
  rangeAreaTooltip: 'Tartomány terület',
  boxPlotTooltip: 'Box Plot',
  treemapTooltip: 'Fa diagram',
  sunburstTooltip: 'Sunburst',
  waterfallTooltip: 'Vízesés',
  heatmapTooltip: 'Hőtérkép',
  columnLineComboTooltip: 'Oszlop és vonal',
  areaColumnComboTooltip: 'Terület és oszlop',
  customComboTooltip: 'Egyedi kombináció',
  innerRadius: 'Belső sugár',
  startAngle: 'Kezdőszög',
  endAngle: 'Végszög',
  reverseDirection: 'Irány váltás',
  groupPadding: 'Csoport kitöltés',
  seriesPadding: 'Sorozat kitöltés',
  tile: 'Csempe',
  whisker: 'Bajusz',
  cap: 'Sapka',
  capLengthRatio: 'Hossz arány',
  labelPlacement: 'Címke elhelyezés',
  inside: 'Belül',
  outside: 'Kívül',
  noDataToChart: 'Nincs ábrázolható adat.',
  pivotChartRequiresPivotMode: 'A Pivot diagramhoz Pivot mód szükséges.',
  chartSettingsToolbarTooltip: 'Menü',
  chartLinkToolbarTooltip: 'Hálózathoz csatlakoztatva',
  chartUnlinkToolbarTooltip: 'Hálózattól leválasztva',
  chartDownloadToolbarTooltip: 'Diagram letöltése',
  chartEdit: 'Diagram szerkesztése',
  chartAdvancedSettings: 'Haladó beállítások',
  chartLink: 'Csatlakozás a hálózathoz',
  chartUnlink: 'Leválasztás a hálózatról',
  chartDownload: 'Diagram letöltése',
  seriesChartType: 'Sorozat diagram típusa',
  seriesType: 'Sorozat típusa',
  secondaryAxis: 'Másodlagos tengely',
  seriesAdd: 'Sorozat hozzáadása',
  categoryAdd: 'Kategória hozzáadása',
  advancedSettings: 'Haladó beállítások',
  direction: 'Irány',
  horizontal: 'Vízszintes',
  vertical: 'Függőleges',
  seriesGroupType: 'Csoport típusa',
  groupedSeriesGroupType: 'Csoportosított',
  stackedSeriesGroupType: 'Halmozott',
  normalizedSeriesGroupType: '100% Halmozott',

  // ARIA
  ariaAdvancedFilterBuilderItem: `${VARIABLE}. Szint ${VARIABLE}. Nyomja meg az ENTER gombot a szerkesztéshez.`,
  ariaAdvancedFilterBuilderItemValidation: `${VARIABLE}. Szint ${VARIABLE}. ${VARIABLE} Nyomja meg az ENTER gombot a szerkesztéshez.`,
  ariaAdvancedFilterBuilderList: 'Haladó Szűrő Építő Lista',
  ariaAdvancedFilterBuilderFilterItem: 'Szűrő Feltétel',
  ariaAdvancedFilterBuilderGroupItem: 'Szűrő Csoport',
  ariaAdvancedFilterBuilderColumn: 'Oszlop',
  ariaAdvancedFilterBuilderOption: 'Opció',
  ariaAdvancedFilterBuilderValueP: 'Érték',
  ariaAdvancedFilterBuilderJoinOperator: 'Csatlakozási operátor',
  ariaAdvancedFilterInput: 'Haladó Szűrő Bemenet',
  ariaChecked: 'bejelölve',
  ariaColumn: 'Oszlop',
  ariaColumnGroup: 'Oszlop csoport',
  ariaColumnFiltered: 'Oszlop szűrve',
  ariaColumnSelectAll: 'Összes oszlop kiválasztása váltás',
  ariaDateFilterInput: 'Dátumszűrő bemenet',
  ariaDefaultListName: 'Lista',
  ariaFilterColumnsInput: 'Oszlopok szűrése bemenet',
  ariaFilterFromValue: 'Szűrés ettől az értéktől',
  ariaFilterInput: 'Szűrő bemenet',
  ariaFilterList: 'Szűrő lista',
  ariaFilterToValue: 'Szűrés eddig az értékig',
  ariaFilterValue: 'Szűrő érték',
  ariaFilterMenuOpen: 'Szűrő menü megnyitása',
  ariaFilteringOperator: 'Szűrő operátor',
  ariaHidden: 'rejtett',
  ariaIndeterminate: 'határozatlan',
  ariaInputEditor: 'Bemenet szerkesztő',
  ariaMenuColumn: 'Nyomja meg az ALT LE gombot az oszlop menü megnyitásához',
  ariaFilterColumn: 'Nyomja meg a CTRL ENTER gombot a szűrő megnyitásához',
  ariaRowDeselect: 'Nyomja meg a SPACE gombot a sor kijelölésének törléséhez',
  ariaRowSelectAll: 'Nyomja meg a Space gombot az összes sor kijelölésének váltásához',
  ariaRowToggleSelection: 'Nyomja meg a Space gombot a sor kijelölésének váltásához',
  ariaRowSelect: 'Nyomja meg a SPACE gombot a sor kijelöléséhez',
  ariaRowSelectionDisabled: 'A sor kijelölése le van tiltva ennél a sornál',
  ariaSearch: 'Keresés',
  ariaSortableColumn: 'Nyomja meg az ENTER gombot a rendezéshez',
  ariaToggleVisibility: 'Nyomja meg a SPACE gombot a láthatóság váltásához',
  ariaToggleCellValue: 'Nyomja meg a SPACE gombot a cella értékének váltásához',
  ariaUnchecked: 'nincs bejelölve',
  ariaVisible: 'látható',
  ariaSearchFilterValues: 'Keresés szűrő értékek',

  // ARIA Labels for Drop Zones
  ariaRowGroupDropZonePanelLabel: 'Sor csoportok',
  ariaValuesDropZonePanelLabel: 'Értékek',
  ariaPivotDropZonePanelLabel: 'Oszlop címkék',
  ariaDropZoneColumnComponentDescription: 'Nyomja meg a DELETE gombot az eltávolításhoz',
  ariaDropZoneColumnValueItemDescription: 'Nyomja meg az ENTER gombot az összesítés típusának megváltoztatásához',
  ariaDropZoneColumnGroupItemDescription: 'Nyomja meg az ENTER gombot a rendezéshez',
  // used for aggregate drop zone, format: {aggregation}{ariaDropZoneColumnComponentAggFuncSeparator}{column name}
  ariaDropZoneColumnComponentAggFuncSeparator: ' közül ',
  ariaDropZoneColumnComponentSortAscending: 'növekvő',
  ariaDropZoneColumnComponentSortDescending: 'csökkenő',

  // ARIA Labels for Dialogs
  ariaLabelColumnMenu: 'Oszlop menü',
  ariaLabelColumnFilter: 'Oszlop szűrő',
  ariaLabelCellEditor: 'Cella szerkesztő',
  ariaLabelDialog: 'Párbeszéd',
  ariaLabelSelectField: 'Mező kiválasztása',
  ariaLabelRichSelectField: 'Rich kiválasztási mező',
  ariaLabelTooltip: 'Tooltip',
  ariaLabelContextMenu: 'Környezet menü',
  ariaLabelSubMenu: 'Almenü',
  ariaLabelAggregationFunction: 'Összesítési függvény',
  ariaLabelAdvancedFilterAutocomplete: 'Haladó szűrő automatikus kiegészítés',
  ariaLabelAdvancedFilterBuilderAddField: 'Haladó szűrő építő mező hozzáadása',
  ariaLabelAdvancedFilterBuilderColumnSelectField: 'Haladó szűrő építő oszlop kiválasztási mező',
  ariaLabelAdvancedFilterBuilderOptionSelectField: 'Haladó szűrő építő opció kiválasztási mező',
  ariaLabelAdvancedFilterBuilderJoinSelectField: 'Haladó szűrő építő csatlakozási operátor kiválasztási mező',

  // ARIA Labels for the Side Bar
  ariaColumnPanelList: 'Oszlop lista',
  ariaFilterPanelList: 'Szűrő lista',

  // Number Format (Status Bar, Pagination Panel)
  thousandSeparator: ',',
  decimalSeparator: '.',

  // Data types
  true: 'Igaz',
  false: 'Hamis',
  invalidDate: 'Érvénytelen dátum',
  invalidNumber: 'Érvénytelen szám',
  january: 'Január',
  february: 'Február',
  march: 'Március',
  april: 'Április',
  may: 'Május',
  june: 'Június',
  july: 'Július',
  august: 'Augusztus',
  september: 'Szeptember',
  october: 'Október',
  november: 'November',
  december: 'December',

  // Time formats
  timeFormatSlashesDDMMYYYY: 'DD/MM/YYYY',
  timeFormatSlashesMMDDYYYY: 'MM/DD/YYYY',
  timeFormatSlashesDDMMYY: 'DD/MM/YY',
  timeFormatSlashesMMDDYY: 'MM/DD/YY',
  timeFormatDotsDDMYY: 'DD.M.YY',
  timeFormatDotsMDDYY: 'M.DD.YY',
  timeFormatDashesYYYYMMDD: 'YYYY-MM-DD',
  timeFormatSpacesDDMMMMYYYY: 'DD MMMM YYYY',
  timeFormatHHMMSS: 'HH:MM:SS',
  timeFormatHHMMSSAmPm: 'HH:MM:SS',
};
